import React, {Component} from 'react';
import Designtab from "./Features/Designtab";

class DeveloperTab extends Component {
    render() {
        return (
            <section className="developer_product_area" id="documents">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 d-flex align-items-center">
                            <div className="developer_product_content">
                                <h2 className="f_600 f_size_30 l_height30 t_color3 mb_50 wow fadeInUp"
                                    data-wow-delay="0.2s">Documents & Presentations</h2>
                                <ul className="nav nav-tabs develor_tab mb-30" id="myTab2" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" data-tab="tab_one" id="ruby-tab"
                                           data-toggle="tab" href="#ruby" role="tab" aria-controls="ruby"
                                           aria-selected="true">Presentations </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-tab="tab_two" id="curl-tab" data-toggle="tab"
                                           href="#curl" role="tab" aria-controls="curl" aria-selected="false">Initial
                                            Docs</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-tab="tab_three" data-toggle="tab" href="#resize"
                                           role="tab" aria-controls="resize" aria-selected="true">Final Docs</a>
                                    </li>
                                    {/*<li className="nav-item">*/}
                                    {/*    <a className="nav-link" data-tab="tab_four" id="doctl-tab" data-toggle="tab" href="#doctl" role="tab" aria-controls="doctl" aria-selected="false">Senura</a>*/}
                                    {/*</li>*/}
                                </ul>
                                <div className="tab-content developer_tab_content">
                                    <div className="tab-pane fade show active" id="ruby" role="tabpanel"
                                         aria-labelledby="ruby-tab">
                                        <table className="table table-striped">
                                            <tbody>
                                            <tr className="row">
                                                <th scope="row">1</th>
                                                <td className="col-8">Proposal Presentation</td>
                                                <td>
                                                    <a href="https://drive.google.com/file/d/1wUwMBhNucwHdExZuR2pVHyH0JIbSkr3m/view?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr className="row">
                                                <th scope="row">2</th>
                                                <td className="col-8">Progress Presentation I (50%)</td>
                                                <td>
                                                    <a href="https://drive.google.com/file/d/1cI8pdXzKy33wRNrD3t3OWEeJ8vY1giV6/view?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr className="row">
                                                <th scope="row">3</th>
                                                <td className="col-8">Progress Presentation II (90%)</td>
                                                <td>
                                                    <a href="https://drive.google.com/file/d/1jLEnh7eFgBM_q8-8r28y_Pb1Tx9lv3aQ/view?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                    <div className="tab-pane fade" id="curl" role="tabpanel" aria-labelledby="curl-tab">
                                        <table className="table table-striped">
                                            <tbody>
                                            <tr className="row">
                                                <th scope="row">1</th>
                                                <td className="col-8">Topic Assessment</td>
                                                <td>
                                                    <a href="https://drive.google.com/file/d/1YgDRv3wnkXUn-MX0xeQqjR65S9m65DM-/view?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr className="row">
                                                <th scope="row">2</th>
                                                <td className="col-8">Project Charter</td>
                                                <td>
                                                    <a href="https://drive.google.com/file/d/1Dol-LRb8PUucYziDTzCBo25ApNF-Tar6/view?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr className="row">
                                                <th scope="row">3</th>
                                                <td className="col-8">Project Proposal</td>
                                                <td>
                                                    <a href="https://drive.google.com/drive/folders/1CrVj0r8YsGZHAif1JsNzey7C7DeklK-b?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="tab-pane fade" id="resize" role="tabpanel"
                                         aria-labelledby="resize-tab">
                                        <table className="table table-striped">
                                            <tbody>
                                            <tr className="row">
                                                <th scope="row">1</th>
                                                <td className="col-8">Research Paper</td>
                                                <td>
                                                    <a href="https://drive.google.com/file/d/11NjLOp_z0KZzmLEiT9JrsZgxnCFLAfKJ/view?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr className="row">
                                                <th scope="row">2</th>
                                                <td className="col-8">Final Reports</td>
                                                <td>
                                                    <a href="https://drive.google.com/drive/folders/1oAJRU-MNZRNYyoEUr8cjERPMiCO_HX_6?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr className="row">
                                                <th scope="row">3</th>
                                                <td className="col-8">Status Document</td>
                                                <td>
                                                    <a href="https://drive.google.com/file/d/1BkGz996lBDTdSmPvPpKvTawv2nFxhGK5/view?usp=sharing"
                                                       target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                                        <i className="ti-download"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    {/*<div className="tab-pane fade" id="doctl" role="tabpanel" aria-labelledby="doctl-tab">*/}
                                    {/*    <p className="mb_40">Senura-boo cheers plastered twit chimney pot off his nut hotpot spend a penny have it, so I said squiffy A bit of how's your father mufty pukka knees up absolutely bladdered brown bread, James Bond boot spiffing ummm I'm telling vagabond arse over tit burke. He lost his bottle mush old spend a penny wellies gormless bite.!</p>*/}
                                    {/*    <a href="/#" className="details_btn">API Documentation</a>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="tab_img_info">
                                <div className="tab_img active" id="tab_one">
                                    <img className="img-fluid wow fadeInRight" data-wow-delay="0.4s"
                                         src={require("../img/home5/files-pana.png")} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <br/>

                    <Designtab/>
                </div>
            </section>
        )
    }
}

export default DeveloperTab;
